import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import BaseDetailScreen from '../BaseDetailScreen';
import getCustomerAgreementsText from './CustomerAgreementsText';


const Component = (props) => {
  let backInfo = {
    to: props.backTo || '/sign-up/signature',
    label: props.backLabel || 'Return to Sign Up',
  };

  if (props.location.state && props.location.state.isBankLink) {
    const { previousLink } = props.location.state;
    backInfo = {
      to: previousLink,
      label: 'Return to Bank Linking',
    };
  }
  if (!('firstName' in props.identity)) {
    return <Redirect to="/login" push={false} />;
  }

  return (
    <BaseDetailScreen
      pageHeading="Customer Agreements"
      pageSubheading="Thank you for reviewing the customer agreements
        before completing the sign up process"
      backTo={backInfo.to || '/sign-up/signature'}
      backLabel={backInfo.label || 'Return to Sign Up'}
    >
      { getCustomerAgreementsText() }
    </BaseDetailScreen>
  );
};

const mapStateToProps = state => ({
  identity: state.rrSignupForms.personalInfo.identity,
});

Component.displayName = 'CertificationAgreement';

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/SignUp/CustomerAgreements.js